/**
 * Card color swatches behaviour.
 *
 * - Clicking a `.swatch_e` navigates to its `data-url` (that color's product).
 * - Hovering a `.swatch_e[hover_featured_image]` swaps the card's main image to
 *   the sibling color's image; leaving restores the original.
 *
 * Uses delegated listeners so it works for every card on the page, including
 * cards added later (carousel, infinite scroll, section re-render).
 */

const IMAGE_SELECTOR = '.product-media__image, .card-gallery img, img';

/** @param {HTMLElement} swatch */
function cardImageFor(swatch) {
  const card = swatch.closest('.product-card') || swatch.closest('[data-product-id]');
  if (!card) return null;
  return card.querySelector(IMAGE_SELECTOR);
}

/** @param {Event} event */
function onOver(event) {
  const swatch = event.target instanceof Element ? event.target.closest('.swatch_e') : null;
  if (!swatch) return;

  const src = swatch.getAttribute('hover_featured_image');
  if (!src) return;

  const img = cardImageFor(swatch);
  if (!img) return;

  if (!img.dataset.originalSrc) {
    img.dataset.originalSrc = img.getAttribute('src') || '';
    img.dataset.originalSrcset = img.getAttribute('srcset') || '';
  }
  img.setAttribute('src', src);
  img.removeAttribute('srcset');
}

/** @param {Event} event */
function onOut(event) {
  const swatch = event.target instanceof Element ? event.target.closest('.swatch_e') : null;
  if (!swatch || !swatch.getAttribute('hover_featured_image')) return;

  const img = cardImageFor(swatch);
  if (!img || img.dataset.originalSrc == null) return;

  img.setAttribute('src', img.dataset.originalSrc);
  if (img.dataset.originalSrcset) img.setAttribute('srcset', img.dataset.originalSrcset);
  delete img.dataset.originalSrc;
  delete img.dataset.originalSrcset;
}

/** @param {Event} event */
function onClick(event) {
  const swatch = event.target instanceof Element ? event.target.closest('.swatch_e') : null;
  if (!swatch) return;

  const url = swatch.getAttribute('data-url');
  if (!url) return;

  event.preventDefault();
  event.stopPropagation();
  window.location.href = url;
}

if (!window.__cardColorSwatchesInit) {
  window.__cardColorSwatchesInit = true;
  document.addEventListener('pointerover', onOver);
  document.addEventListener('pointerout', onOut);
  document.addEventListener('click', onClick, true);
}
